module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet"
  }, [_vm._v("Mis Reportes 6 (8 tablet)")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--6-col-tablet"
  }, [_vm._v("Mis Reportes 4 (6 tablet)")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--4-col-phone"
  }, [_vm._v("Mis Reportes 2 (4 phone)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db76ddc4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Report/index.vue
// module id = 255
// module chunks = 0